'use client';
import styles from '../../page.module.scss';
import { useEffect, useState } from 'react';

export default function MainHedaer() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShow(true), 500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={`${styles.mainImageContainer} ${!show && styles.slowShow}`}>
      <img
        className={styles.mainImage}
        src={
          'https://res.cloudinary.com/dsw6fpqoz/image/upload/v1751615091/lalibre-editora/foto_la_libre_mqzeda.jpg'
        }
        alt="Imagen de la librería"
        fetchPriority="high"
        loading="eager"
      />
      <div className={styles.logoContainer}>
        <img
          className={styles.logoImage}
          src={
            'https://res.cloudinary.com/dsw6fpqoz/image/upload/v1752244866/lalibre-editora/logo-la-libre-editora_onkz2l.png'
          }
          alt="Logo de La Libre"
          onLoad={() => console.log('Image loaded')}
        />
      </div>
      <div className={styles.mainSign}>
        <p>Cooperativa de Libros y Cultura</p>
        <p>Chacabuco 917, San Telmo, </p>
        <p> Ciudad de Buenos Aires.</p>
      </div>
    </div>
  );
}
